import type { CSSProperties } from 'react';

/**
 * Visually hidden, still announced (gap G31).
 *
 * Three dashboard routes each carried their own copy of this exact clip-rect
 * incantation, under three different names. It is the kind of thing that gets
 * pasted rather than imported, and a subtly wrong copy — `display: none`, or a
 * missing `white-space` — silently removes the text from screen readers too,
 * which is the one job it has.
 *
 * `clip` is deprecated CSS and still required: `clip-path` alone is not honoured
 * by every assistive stack, so both are kept.
 */
export const srOnly: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
